import { replacePlaceholders } from "../layout/documentLayout";
import { BarTitle, PrintBlock } from "./printStyles";
import type { QuestionViewProps } from "./types";

// bigHeader, smallHeader -> the PDF's Title block: a grey rounded bar, weight 600.

export function HeaderQuestionView({ block, placeholders }: QuestionViewProps) {
  return (
    <PrintBlock>
      <BarTitle>{replacePlaceholders(block.question.label, placeholders)}</BarTitle>
    </PrintBlock>
  );
}
